module.exports = __webpack_public_path__ + "assets/logout_icon.36a830a3.svg";